<template>
  <div>
    <!-- 标题 -->
    <!-- <div>
        <van-nav-bar title="资讯详情" />
      </div> -->
    <!-- 内容 -->
    <div :class="list.openId!=openId?'essay':'essay essayheight'">
      <div class="essayTitle" style="font-size: 18px;text-align: center;">{{ list.title }}</div>
      <!-- <div class="rikind">{{ list.IssTime }}</div> -->
      <!-- <div v-if="list.ThematicUrl"
          class="essayImg">
          <img :src="list.ThematicUrl"
            alt=""
            @click="thematic(list.ThematicUrl)" />
        </div> -->
      <p
        class="essayContent"
        style="margin-top: 0"
        v-html="list.content"
        @click="imageEnlargement"
      ></p>
      <div class="video" v-if="list.Video">
        <video style="width: 100%" :src="list.Video" controls="controls">
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div
        class="video"
        v-if="list.Annex"
        style="color: #1989fa; margin: 0 10px"
        @click="gotoUrl(list.Annex)"
      >
        <a
          :href="list.Annex"
          style="color: #1989fa"
          download="附件"
          class="video"
        >
          附件链接
        </a>
      </div>
      <!-- <div class="rikind" style="text-align: right;">阅读：{{ list.ReadNum }}</div> -->
      <div class="rikind" style="text-align: right">{{ list.CreateTime }}</div>

      <div class="privateLetter" v-show="list.openId!=openId">
<!--        <a :href="list.phone|setPhone" v-if="list.phone"><div class="privateLetterB">{{list.isPublic==0?'联系社区':'电话联系'}}</div></a>-->
<!--        <div class="privateLetterB" @click="privateLetter()" style="  margin-right:0%;">私信聊天</div>-->
        <a :href="list.phone|setPhone" v-show="list.phone"><div class="privateLetterB">{{list.isPublic==0?'联系社区':'电话联系'}}</div></a>
        <div class="privateLetterBN" v-show="list.phone==null||list.phone==''">{{list.isPublic==0?'联系社区':'电话联系'}}</div>
        <div class="privateLetterB" @click="privateLetter()" style="  margin-right:0%;">私信聊天</div>
      </div>


      <!-- <div id="demo"
          class="m-pdf"></div> -->

      <!-- <iframe style="width:100%;height:78vh;" :src="pdf"></iframe> -->
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
// import { WeWorkreportInfo, WePBEnrolActivity } from "@/api/RealInfo";
  import { getEmployment} from '@/api/Changan-zhsq/Employment'
import { setOpenId, getOpenId } from "@/utils/auth";
import { Dialog } from "vant";
import Pdfh5 from "pdfh5";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      openId:'',
      list: {},
      pdf: "",
      pdfh5: "",
    };
  },
  filters: {
    setPhone(val) {
      let content='tel:'+val;
      return content
    }
  },
  methods: {
    // goPhone(){
    //   wx.makePhoneCall({
    //     phoneNumber: this.data.phoneNumber,
    //   })
    // },
    privateLetter(){
      let that=this;
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "/pages/send/index?user_id=" + that.list.openId + '&head_img_url=' + that.list.headImg + '&nick_name=' + that.list.name,
        });
        // }, 100);
      } else {
        alert("请在微信小程序中打开");
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        // this.$router.push(path);
      }
    },
    gotoUrl(url) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/downLoading?url=" + url,
        });
        // }, 100);
      } else {
        alert("请在微信小程序中打开");
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        // this.$router.push(path);
      }
    },
    thematic(e) {
      ImagePreview({
        images: [e], // 传递的是图片集数组
        startPosition: 0, // 图片索引位置
        closeable: true, // 是否显示关了按钮
        showIndicators: true, // 是否显示轮播指示器
        loop: false, // 不设置为false,首图和尾部图不能正常加载
      });
    },
    // 富文本图片内容 点击放大
    imageEnlargement(e) {
      if (e.target.nodeName === "IMG") {
        ImagePreview({
          images: [e.target.src], // 传递的是图片集数组
          startPosition: 0, // 图片索引位置
          closeable: true, // 是否显示关了按钮
          showIndicators: true, // 是否显示轮播指示器
          loop: false, // 不设置为false,首图和尾部图不能正常加载
        });
      }
    },
    // 获取资讯详情 https://api.qxzhqm.cn//upload/files/2022/3/20211217-老城区民营经济综合服务平台（PC端）(1)(1).docx
    getRealInfo() {
      this.openId=this.$route.query.openid
      let params={
        id:this.$route.params.id,
        openId:this.$route.query.openid
      }
      getEmployment(params).then((res) => {
        console.log(res)
        this.list = res.data.data;
        // axios.default.baseURL = 'https://api.qxzhqm.cn//upload/files/2022/3/ThingJS-X应用模板制作标准.pdf'
        // this.pdf = axios.default.baseURL + '/upload/files/2022/3/ThingJS-X应用模板制作标准.pdf'
        // this.pdf = '/upload/files/2022/3/ThingJS-X应用模板制作标准.pdf'
        // // this.pdf = '/upload/files/2022/3/20211217-老城区民营经济综合服务平台（PC端）(1)(1).docx'
        // console.log(this.pdf)
        // this.pdfh5 = new Pdfh5('#demo', {
        //   pdfurl: '../api' + this.pdf,
        // })
        // //监听完成事件
        // this.pdfh5.on('complete', function(status, msg, time) {
        //   console.log('状态：' + status + '，信息：' + msg + '，耗时：' + time + '毫秒，总页数：' + this.totalNum)
        // })
        // this.list.Content = this.list.Content.replace(/<.*?>/ig,"")
        // console.log(this.list.Content);
      });
      // this.activated()
    },

    activated() {
      var _this = this;
      _this.uuid = _this.$route.query.uuid;
      var shareUrl = global.BASE_SHARE_URL + "grade?uuid=" + _this.uuid;
      this.$wxShare.updateWxShareConfig({
        title: "标题",
        desc: "简介",
        link: shareUrl,
      });
    },
  },
  mounted() {
    this.getRealInfo();
  },
};
</script>
<style scoped>

</style>
<style>
.essay .essayContent img {
  display: inline;
  max-width: 100%;
}
.pageNum-num {
  display: none;
}
.m-pdf img {
  width: 100%;
}
.button {
  width: 95%;
  margin: 15px 2.5%;
}
/* table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
}
th, td {
  border: 1px solid #ddd;
} */
.privateLetter{
  position: fixed;
  bottom: 5%;
  left: 10%;
  right: 20%;
  /* padding: 0px 10%; */
  width: 80%;
}
.privateLetterB{
  width: 47%;
  height: 60px;
  background-color:#0c9565 ;
  line-height: 60px;
  text-align: center;
  border-radius: 8px;
  float: left;
  margin-right:5%;
  color: #ffffff;
}

.privateLetterBN{
  width: 47%;
  height: 60px;
  background-color: #959595;
  line-height: 60px;
  text-align: center;
  border-radius: 8px;
  float: left;
  margin-right:5%;
  color: #ffffff;
}
</style>
